import React from 'react';

// Constants
import { Data } from './QuickStartGuideCompletionModalData.constants';

// Components
import NewFeatureCarouselModal from 'Dashboard/components/NewFeatureCarouselModal/NewFeatureCarouselModal';
import { WpButton } from 'Wpds/components/button';

type Props = {
  isOpen: boolean;
  toggleIsOpen: () => void;
};

const QuickStartGuideCompletionModal = ({ isOpen, toggleIsOpen }: Props) => {
  const handleGuidesLinkClick = () => {
    const element = document.createElement('a');
    element.href = 'https://docs.predictiveindex.com/perform/overview/getting-started-with-perform/';
    element.target = '_blank';
    element.rel = 'noopener noreferrer';
    document.body.appendChild(element);
    element.click();
    element.remove();
  };

  return (
    <NewFeatureCarouselModal
      isOpen={isOpen}
      toggleIsOpen={toggleIsOpen}
      data={Data}
      additionalButton={
        <WpButton variant="tertiary" onClick={handleGuidesLinkClick}>
          View Perform Guides
        </WpButton>
      }
    />
  );
};

export default QuickStartGuideCompletionModal;
